import React from 'react';

const DatWorkedTableHeader = () => {
  return (
    <div style={{ display: 'flex' }}>
      <div
        style={{ width: '20%', paddingLeft: '0px' }}
        className={'add_user_fourth_step_table_header'}
      >
        Day
      </div>
      <div
        style={{ width: '25%' }}
        className={'add_user_fourth_step_table_header'}
      >
        Time Slot 1 {'     '} (AM)
      </div>
      <div
        style={{ width: '25%' }}
        className={'add_user_fourth_step_table_header'}
      >
        Time Slot 2 {'     '} (PM)
      </div>
      <div
        style={{ width: '10%' }}
        className={'add_user_fourth_step_table_header'}
      >
        Total Hours
      </div>
      <div
        style={{ width: '20%' }}
        className={'add_user_fourth_step_table_header'}
      >
        Leave Management
      </div>
    </div>
  );
};

export default DatWorkedTableHeader;
